/* ---------- FOR SLIDER BEGIN ----------- */
var timerIdChange = true;
function setAttributes(attrSet, el) {
    for(var key in attrSet) el.setAttribute(key, attrSet[key]);
}
function initTabSlider(el) {
    var $slideWrapper = el.querySelector('.slider-wrapper');
    var displaySlides = function (item,min,max) {
        var $slider = item;
        var $slide = $slider.querySelectorAll('.slider-item:not(.slider-item-link)');
        var $currentSlide = $slider.querySelector('[data-count-current]');
        var $minSlide = $slider.querySelector('[data-count-min]');
        var $maxSlide = $slider.querySelector('[data-count-max]');
        var $countSlide = $slider.querySelector('[data-count-length]');
        var $btnPrev = $slider.querySelector('.slider-button-prev');
        var $btnNext = $slider.querySelector('.slider-button-next');
        var countDots = 1;
        var initDots = true;
        var dots = function (count) {
            var sliderDots = $slider.querySelector('.slider-dots');
            var sliderDotsItem = document.createElement('span');
            sliderDotsItem.classList.add('slider-dots-item');
            if(initDots) sliderDotsItem.classList.add('current'), initDots = false;
            sliderDotsItem.setAttribute('data-dots-item', count);
            sliderDotsItem.addEventListener('click', changeSlides);
            sliderDots.append(sliderDotsItem)
        }
        if(!$slider.classList.contains('slider-init')){
            for(var j = 0; j < $slide.length; j++){
                $slide[j].setAttribute('data-slide', j + 1);
                if ($slider.getAttribute('data-slider-action') === 'dots'){
                    if(j%columnSlider($slider) === 0) dots(countDots), countDots = countDots + columnSlider($slider);
                }
            }
            $btnPrev.addEventListener('click', changeSlides);
            $btnNext.addEventListener('click', changeSlides);
            $slider.classList.add('slider-init');
        }else{
            if($slider.getAttribute('data-slider-action') === 'dots'){
                var actualDots = $slider.querySelectorAll('.slider-dots-item');
                var actualDotsCount = 0;
                for(var j = 0; j < $slide.length; j++) if(j%columnSlider($slider) === 0) actualDotsCount++;
                if(actualDots.length !== actualDotsCount){
                    removeChildAll(actualDots);
                    countDots = 1;
                    initDots = true;
                    for(var j = 0; j < $slide.length; j++){
                        if(j%columnSlider($slider) === 0) dots(countDots), countDots = countDots + columnSlider($slider);
                    }
                }
            }
        }
        for(var j = 0; j < $slide.length; j++){
            if ($slider.getAttribute('data-slider-action') === 'carousel'){
                ((j + 1) < min)||((j + 1) > max) ? $slide[j].classList.add('fade') : $slide[j].classList.remove('fade');
            }else{
                ((j + 1) < min)||((j + 1) > max) ? $slide[j].classList.add('hidden') : $slide[j].classList.remove('hidden');
            }
            if($currentSlide && !$slide[j].classList.contains('hidden')) setAttributes({'data-count-current':  '0' + (j + 1)}, $currentSlide);
        }
        if($minSlide) $minSlide.setAttribute('data-count-min', (min < 10 ? '0' + min : min));
        if($maxSlide) $maxSlide.setAttribute('data-count-max',  (max < 10 ? '0' + max : max));
        if($countSlide) $countSlide.setAttribute('data-count-length',  ($slide.length < 10 ? '0' + $slide.length : $slide.length));
        setAttributes({'data-count-view-min': min, 'data-count-view-max': max}, $slider);
        min === 1 ? $btnPrev.classList.add('slider-button-deActive') : $btnPrev.classList.remove('slider-button-deActive');
        max === $slide.length ? $btnNext.classList.add('slider-button-deActive') : $btnNext.classList.remove('slider-button-deActive');
    }
    var changeSlides = function (e) {
        if(e.target) e.stopPropagation(), e.preventDefault();
        var $slider = e.target ? this.closest('[data-slider="sliderTab"]') : e;
        var $viewSlideMin = parseInt($slider.getAttribute('data-count-view-min'));
        var $viewSlideMax = parseInt($slider.getAttribute('data-count-view-max'));
        if(e.target){
            if (this.classList.contains('slider-button')){
                if(this.classList.contains('slider-button-prev')){
                    if($viewSlideMin > 1) --$viewSlideMin, --$viewSlideMax;
                }else{
                    if($viewSlideMax < $slider.querySelectorAll('.slider-item').length) ++$viewSlideMin, ++$viewSlideMax;
                }
            }else if(this.classList.contains('slider-dots-item')){
                var count = parseInt(this.getAttribute('data-dots-item'));
                $slider.querySelector('.slider-dots-item.current').classList.remove('current');
                this.classList.add('current');
                $viewSlideMin = count, $viewSlideMax = (count - 1) + columnSlider($slider);
            }
        }else{
            if ($slider.getAttribute('data-slider-action') === 'carousel'){
                if($viewSlideMax < $slider.querySelectorAll('.slider-item:not(.slider-item-link)').length){
                    ++$viewSlideMin, ++$viewSlideMax;
                }else{
                    $viewSlideMin = 1, $viewSlideMax = columnSlider($slider);
                }
            }
        }
        if($slider.querySelectorAll('.slider-item').length) displaySlides($slider,$viewSlideMin,$viewSlideMax);
        if($slider.querySelectorAll('.announce').length) readMore();
    }
    var carousel = function (el){
        var delay = 10000;
        var timerId = setTimeout(function request() {
            if(timerIdChange){
                changeSlides(el);
            }
            timerIdChange = false;
            setTimeout(function () {
                timerIdChange = true;
                timerId = setTimeout(request, delay);
            }, delay);
        }, delay);
    }
    $slideWrapper.setAttribute('data-column', columnSlider(el));
    if(el.querySelectorAll('.slider-item').length > columnSlider(el)){
        displaySlides(el, 1, columnSlider(el));
        if (el.getAttribute('data-slider-action') === 'carousel') carousel(el);
    } else{
        if(el.classList.contains('slider-init')) destroyTabSlider(el);
    }
}
function columnSlider($slider) {
    var setColumn;
    if($slider.classList.contains('ladies__gallery')){
        setColumn = $wW > 1350 ? 5 :($wW > 768 ? 4 : ($wW > 480 ? 3 : 1));
    }
    if($slider.classList.contains('welcome__gallery')){
        setColumn = $wW > 568 ? 3 : ($wW > 480 ? 2 : 1);
    }
    if($slider.classList.contains('comment__gallery')){
        setColumn = $wW > 1279 ? 3 :($wW > 1024 ? 5 : ($wW > 768 ? 4 : ($wW > 568 ? 3 : ($wW > 480 ? 2 : 1))));
    }
    return setColumn;
}
function destroyTabSlider(el){
    if (!document.querySelectorAll('[data-slider="sliderTab"]').length) return;
    var $slider = el;
    var $slideWrapper = $slider.querySelector('.slider-wrapper');
    var displayClear = function ($slider) {
        var $slide = $slider.querySelectorAll('.slider-item');
        if($slider.classList.contains('slider-init')){
            for(var j = 0; j < $slide.length; j++) $slide[j].classList.remove('hidden');
        }
    }
    $slideWrapper.setAttribute('data-column', columnSlider($slider));
    displayClear($slider);
    $slider.classList.remove('slider-init');
}
function updateTabSlider(el) {
    if (!document.querySelectorAll('[data-slider="sliderTab"]').length) return;
    var slides = el.querySelectorAll('.slider-item');
    var min = el.getAttribute('data-count-view-min');
    var max = el.getAttribute('data-count-view-max');
    for(var i = 0; i < slides.length; i++){
        slides[i].setAttribute('data-slide', i + 1);
        if (el.getAttribute('data-slider-action') !== 'carousel'){
            ((i + 1) < min)||((i + 1) > max) ? slides[i].classList.add('hidden') : slides[i].classList.remove('hidden');
        }else{
            ((i + 1) < min)||((i + 1) > max) ? slides[i].classList.add('fade') : slides[i].classList.remove('fade');
        }
    }
}
function initResizeTabSlider(){
    if (!document.querySelectorAll('[data-slider="sliderTab"]').length) return;
    var sliderTab = document.querySelectorAll('[data-slider="sliderTab"]');
    for(var i = 0; i < sliderTab.length; i ++) initTabSlider(sliderTab[i]);
}
/* ---------- FOR SLIDER END ----------- */